import React, { useEffect, useState, useRef } from 'react';
import { map, uniqBy } from 'lodash';

import ProductSlider from './ProductSlider.jsx';
import { post } from '../../../common/httpService';
import translateService from '../../../common/translateService';
import expirationStorageService from '../../../common/expirationStorageService';
import common from '../../../common/common';
import './RecentlyViewedProducts.scss';

function RecentlyViewedProducts() {
    const RECENTLY_VIEWED_PRODUCTS =
        'RECENTLY_VIEWED_PRODUCTS_' + common.getSite();
    expirationStorageService.init(RECENTLY_VIEWED_PRODUCTS);

    const [products, setProducts] = useState([]);

    async function getProductsBySlugs(array) {
        try {
            post({
                url: `ProductBrowse/GetProductsBySlugsWithColor`,
                body: array,
            }).then((data) => {
                setProducts(data);
            });
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        const visitedProducts =
            expirationStorageService.get({
                key: RECENTLY_VIEWED_PRODUCTS,
            }) || [];
        getProductsBySlugs(
            map(visitedProducts.reverse(), (vp) => vp.url).slice(0, 8)
        );
    }, []);

    if (products && products.length > 0)
        return (
            <>
                <h1 className='section__title'>
                    {translateService.get(
                        `recentlyViewedProducts.recentlyViewedProducts`
                    )}
                </h1>

                <ProductSlider
                    products={uniqBy(
                        products,
                        (p) => p.productUrl
                    )}></ProductSlider>
            </>
        );

    return <></>;
}

export default RecentlyViewedProducts;
